module.exports = __webpack_public_path__ + "img/f32.86d25ac5.jpg";